import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthStore, isTokenValid } from "@/store";
import { ROUTES } from "@/lib/constants";

/** Redirects unauthenticated users to /login, preserving intended destination. */
export function AuthGuard() {
  const { isAuthenticated, clearSession } = useAuthStore();
  const location = useLocation();

  // isAuthenticated can be stale (persisted in localStorage after token expiry).
  // Check the actual JWT expiry before trusting it.
  if (!isAuthenticated || !isTokenValid()) {
    // Clear stale session so the user lands on a clean login page
    if (isAuthenticated) clearSession();
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  return <Outlet />;
}
